import type { AxiosError } from 'axios';

export interface RequestError {
  request: XMLHttpRequest;
}

export const isResponseError = (
  error: unknown,
): error is AxiosError => !!(error && typeof error === 'object' && 'response' in error);

export const isRequestError = (
  error: unknown,
): error is RequestError => !!(error && typeof error === 'object' && 'request' in error);
